import { Box, Card, CardContent, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export default function NoticeBoard({ NoticesData }) {
  const [notices, setNotices] = useState([]);
  function NoticeItem({ text, date, lastSeen }) {
    return (
      <div>
        <Card className='bg-[rgba(254,254,254,0.59)] border border-[#c3c3c3] rounded-lg shadow-none'>
          <CardContent className='flex gap-2 p-2 shadow-none'>
            <Box className='flex flex-col gap-1 flex-1'>
              <div className='flex gap-2'>
                <Typography className='font-medium text-blue-600 '>
                  {date.split('-').reverse().join('-')} :
                </Typography>
                <Typography className='font-medium '>{text}</Typography>
              </div>
              <Typography className='font-medium text-[#929292] text-xs leading-normal text-end'>
                {lastSeen}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </div>
    );
  }
  useEffect(() => {
    setNotices(NoticesData);
  }, []);
  return (
    <>
      <div className=' size-full'>
        {' '}
        <Card className='h-[360px] overflow-y-auto rounded-xl shadow-[2px_2px_10px_0px_rgba(0,0,0,0.08)]'>
          <CardContent className=''>
            <Box className='flex justify-between items-center mb-3'>
              <Typography variant='h6'>Noticeboard</Typography>
            </Box>
            {notices?.length > 0 ? (
              <Box className='flex flex-col gap-1'>
                {notices?.map((notice) => (
                  <NoticeItem
                    key={notice.id}
                    text={notice.message}
                    date={notice.eventDate}
                    lastSeen={notice.timeAgo}
                  />
                ))}
              </Box>
            ) : (
              <div className='flex flex-col justify-center items-center h-[240px]'>
                <Typography variant='body1'> No Notifications</Typography>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </>
  );
}
